module.exports = __webpack_public_path__ + "static/img/img8.f65dcae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img8.png
// module id = z5Q3
// module chunks = 1